import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { ISubvendorInvoiceList } from "./Table";
import { Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface IProps {
    open: boolean;
    close: () => void;
    id: number;
    toast: any;
}

export const History = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: ISubvendorInvoiceList[], loading: boolean });

    const fromDate = (rowData: any) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const generated_Date = (rowData: any) => {
        let date;
        if (rowData.generated_Date) date = format(new Date(rowData.generated_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const toDate = (rowData: any) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const dueDate = (rowData: any) => {
        let date;
        if (rowData.dueDate) date = format(new Date(rowData.dueDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const paymentDate = (rowData: any) => {
        let date;
        if (rowData.payment_Date) date = format(new Date(rowData.payment_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const updatedDate = (rowData: any) => {
        let date;
        if (rowData.updatedOn) date = format(new Date(rowData.updatedOn), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("InvoiceTracking/subvendorInvoiceHistory", "GET", null, `invoiceID=${props.id}`, props.toast);

        if (response) {
            const data: ISubvendorInvoiceList[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    useEffect(() => {
        if (props.open) {
            loadTableData();
        }
    }, [props.open]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Subvendor Invoice History" modal className="p-fluid" onHide={props.close} onShow={loadTableData}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    value={tableData.tableData}
                    loading={tableData.loading}
                    stripedRows resizableColumns showGridlines columnResizeMode="expand"
                    dataKey="id"
                >
                    <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="consultant_Name" header="Name" />
                    <Column field="vendor_Company_Name" header="Sub Vendor" />
                    <Column field="invoiceNO" header="Invoice#" />
                    {/* <Column field="invoiceDate" header="Generated Date" body={generated_Date} />
                    <Column field="fromDate" header="From Date" body={fromDate} />
                    <Column field="toDate" header="To Date" body={toDate} />
                    <Column field="dueDate" header="Due Date" body={dueDate} /> */}
                    <Column field="generated_Date" header="Generated Date" body={(rowData: any) => safeFormatDate(rowData.generated_Date, 'dd/MM/yyyy', DateFormat)} />
                    <Column field="fromDate" header="From Date"  body={(rowData: any) => safeFormatDate(rowData.fromDate, 'dd/MM/yyyy', DateFormat)} />
                    <Column field="toDate" header="To Date"  body={(rowData: any) => safeFormatDate(rowData.toDate, 'dd/MM/yyyy', DateFormat)}/>
                    <Column field="dueDate" header="Due Date"  body={(rowData: any) => safeFormatDate(rowData.dueDate, 'dd/MM/yyyy', DateFormat)} />
                    <Column field="workingHours" header="Hours" />
                    <Column field="bRate" header="B.Rate" />
                    <Column field="invoiceAmount" header="Inv.Amount" />
                    <Column field="requestedAmount" header="Requested Amount" />
                    <Column field="paidAmount" header="Paid Amount" />
                    <Column field="payment_Mode" header="Payment Mode" />
                    <Column field="transaction_ID" header="Transaction" />
                    {/* <Column field="payment_Date" header="Payment Date" body={paymentDate} /> */}
                    <Column field="payment_Date" header="Payment Date" body={(rowData: any) => safeFormatDate(rowData.payment_Date, 'dd/MM/yyyy', DateFormat)} />
                    <Column field="paymentStatus" header="Payment Status" body={(rowData) => <p>{rowData.paymentStatus === "-- SELECT --" ? "" : rowData.paymentStatus}</p>} />
                    <Column field="updatedBy" header="Updated By" />
                    {/* <Column field="updatedOn" header="Updated On" body={updatedDate} /> */}
                    <Column field="updatedOn" header="Updated On" body={(rowData: any) => safeFormatDate(rowData.updatedOn, 'dd/MM/yyyy', DateFormat)} />
                </DataTable>
            </Dialog>
        </>
    );
}